import { Injectable, inject } from '@angular/core';
import {
  GeoIpService,
  ModulePreloadManualStrategyService,
} from '@pedix-workspace/pedixapp-core-services';
import { EstablishmentsCheckoutService } from './establishments-checkout.service';
import { AppRequestContextService } from '../../app-request-context.service';
import { environment } from '../../../environments/environment';
import { StadiaMapsLoaderService } from 'libs/angular/ui/map/src/lib/stadia-maps/stadia-maps-loader.service';

@Injectable({ providedIn: 'root' })
export class CheckoutPreloaderService {
  private modulePreloaderService = inject(ModulePreloadManualStrategyService);
  private establishmentsCheckoutService = inject(EstablishmentsCheckoutService);
  private appRequestContextService = inject(AppRequestContextService);
  private stadiaMapsLoaderService = inject(StadiaMapsLoaderService);
  private geoIpService = inject(GeoIpService);

  private checkoutPreloaded = false;

  preloadCheckout() {
    // Preloads order-checkout module and checkout data for better UX
    if (!this.checkoutPreloaded) {
      try {
        this.modulePreloaderService.preloadModuleByName('order-checkout');
      } catch (error) {
        console.error('[checkout-preloader]: Error preloading order-checkout module');
      }

      this.establishmentsCheckoutService
        .get(this.appRequestContextService.establishment.id)
        .catch(() => {
          console.error('[checkout-preloader]: Error retrieving establishments checkout');
        });

      this.geoIpService.retrieveGeoIpState(environment.workerServicesUrl).catch(() => {
        console.error('[checkout-preloader]: Error retrieving geo IP state');
      });

      try {
        this.stadiaMapsLoaderService.prefetchResources();
      } catch (error) {
        console.error('[checkout-preloader]: Error prefetching stadia maps');
      }

      this.checkoutPreloaded = true;
    }
  }
}
